/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
} from './APIMeta';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
} from './APIResponseError';
import type { TokenV2Response } from './TokenV2Response';
import {
    TokenV2ResponseFromJSON,
    TokenV2ResponseFromJSONTyped,
    TokenV2ResponseToJSON,
} from './TokenV2Response';

/**
 * 
 * @export
 * @interface GetTokenV2200Response
 */
export interface GetTokenV2200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetTokenV2200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetTokenV2200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {TokenV2Response}
     * @memberof GetTokenV2200Response
     */
    result?: TokenV2Response;
}

/**
 * Check if a given object implements the GetTokenV2200Response interface.
 */
export function instanceOfGetTokenV2200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetTokenV2200ResponseFromJSON(json: any): GetTokenV2200Response {
    return GetTokenV2200ResponseFromJSONTyped(json, false);
}

export function GetTokenV2200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTokenV2200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': !exists(json, 'meta') ? undefined : APIMetaFromJSON(json['meta']),
        'errors': !exists(json, 'errors') ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': !exists(json, 'result') ? undefined : TokenV2ResponseFromJSON(json['result']),
    };
}

export function GetTokenV2200ResponseToJSON(value?: GetTokenV2200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': APIMetaToJSON(value.meta),
        'errors': value.errors === undefined ? undefined : ((value.errors as Array<any>).map(APIResponseErrorToJSON)),
        'result': TokenV2ResponseToJSON(value.result),
    };
}

